/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import "../../assets/css/aunjai-welcomepage.css";
import Header from "../Header/Header";

import { useNavigate } from "react-router-dom";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import BottomBar from "../../components/ui/BottomBar/BottomBar";
import { useIsDesktop } from "../../hooks/useIsDesktop";
import SEO from "../../components/seo/SEO";
import FifthSection from "./_components/FifthPart";
import FirstSection from "./_components/FirstPart";
import FourthSection from "./_components/FourthPart";
import SecondSection from "./_components/SecondPart";
import SixthSection from "./_components/SixthPart";
import ThirdSection from "./_components/ThirdPart";
import ComparisonSection from "./_components/ComparisonSection";
import { useTranslation } from "react-i18next";

const FirstPage = () => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [isLogin, setIslogin] = useState(false);
  const [isNotificationListModalOpen, setIsNotificationListModalOpen] =
    useState(false);

  useEffect(() => {
    const savedIdCard = localStorage.getItem("idCard");
    const savedDob = localStorage.getItem("dob");

    if (savedIdCard && savedDob) {
      setIslogin(true);
    } else {
      console.error("Missing credentials");
      setIslogin(false);
    }
  }, []);

  const goSelectLoan = () => {
    if (isLogin) {
      navigate("/select-loan/income");
    } else {
      navigate("/register");
    }
  };

  const isDesktop = useIsDesktop();

  const { t } = useTranslation("home");

  return (
    <div id="PageWelcome">
      <SEO
        title={t("title")}
        description={t("description")}
        url={window.location.href}
        imageUrl={`${window.location.origin}/assets/img/ci/icon/icon-aunjai.svg`}
      />
      <div className="wrapContent">
        <Header title="" showIcon showNotifications />
        {/* <HeroSection /> */}
        <FirstSection />
        <SecondSection />
        <ComparisonSection />
        <ThirdSection />
        <FourthSection />
        <FifthSection />
        <SixthSection />
        {/* <div id="pWelcome">
          <div className="bWelcome">
            <div className="bImg"></div>
            <div className="bContent">
              <div className="bAction">
                <button
                  onClick={goSelectLoan}
                  className="btnLogin"
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <MoonLoader size={20} color="#fff" loading={isLoading} />
                  ) : (
                    "สมัครใช้บริการออนไลน์"
                  )}
                </button>
              </div>
            </div>
            <div className="bBottom">
              <div className="bContentBottom">
                <div className="bText">
                  <h3>ประเภทบริการของเรา</h3>
                </div>
                <div className="bCard">
                  <div className="card">
                    <div className="cardTop">
                      <img
                        src="/assets/img/ci/icon/file-type-1.png"
                        alt="file"
                      ></img>
                      <h2>บริการประเภทที่ 1</h2>
                    </div>
                    <div className="cardBody">
                      <p>
                        วงเงินสูงสุด <span>500,000</span> บาท ค่าบริการเริ่มต้น
                        <span>9.99%</span> ต่อปี
                      </p>
                    </div>
                    <div className="cardBottom">
                      <p>รายละเอียด</p>
                    </div>
                  </div>
                  <div className="card">
                    <div className="cardTop">
                      <img
                        src="/assets/img/ci/icon/file-type-2.png"
                        alt="file"
                      ></img>
                      <h2>บริการประเภทที่ 2</h2>
                    </div>
                    <div className="cardBody">
                      <p>
                        วงเงินสูงสุด <span>1,000,000</span> บาท ค่าบริการเริ่มต้น{" "}
                        <span>5.99%</span> ต่อปี
                      </p>
                    </div>
                    <div className="cardBottom">
                      <p>รายละเอียด</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}
      </div>
      {!isDesktop && (
        <div className="mobile-menu-wrapper">
          <BottomBar />
        </div>
      )}
    </div>
  );
};

export default FirstPage;
